<template lang="pug">
    .shipping
        .body(v-loading="loading" )
            //- .under-construction
            //-     i.el-icon-fa-snowplow.fas
            //-     h4 {{ $t('Under Construction') }}
            //-     p {{ $t('Come back another time') }}
            .tab-content.scroll-box.pending-purchases.shipping(v-dragscroll)
                .empty(v-if="! loading && (! purchases || ! purchases.length)")
                    //- i.el-icon-fa-ghost.fas
                    .icon
                        i.el-icon-fa-slash.fas
                        i.el-icon-fa-circle.far
                    h4 {{ $t('Empty List') }}
                    p {{ $t('There is nothing to see here!') }}
                transition-group(v-else name="slide-decent-vertical" tag="div")
                    shipping-package(
                        v-for="purchase in purchases"
                        :key="purchase.id"
                        :purchase="purchase"
                        :context="$props.context"
                    )
</template>

<script>
import Reserve from './Reserve'
import ShippingPackage from './Partials/ShippingPackage'
import { usePosSetupStore } from '@/stores'

export default {
    name: 'Shipping',
    extends: Reserve,
    components: {
        ShippingPackage,
    },
    props: {
        context: {
            type: String,
            required: true
        }
    },
    computed: {
        posSetupStore() {
            return usePosSetupStore()
        },
        loading() {
            return this.posSetupStore.loadingPendingShippingPurchases
        },
        purchases() {
            return this.posSetupStore.pendingShippingPurchasesItems
        }
    },
    // methods: {
    //     ...mapActions({
    //         fetchCms: 'settings/fetchCms',
    //     })
    // },
    mounted() {
        // this.fetchCms(this.activeCms.id);
        this.$emit('focus-search')
    }
}
</script>

<style lang="sass" scoped>
.tab-content
    width: 100%
    display: flex
    flex-direction: column

.body
    min-height: 10rem
    position: relative
    flex-grow: 1
    /* overflow-x: hidden */
    /* overflow-y: auto */
    /* max-height: 100% */
    /* max-height: calc(100vh - 140px) */
    .scroll-box
        padding: 1rem
        position: absolute
        left: 0
        top: 0
        width: 100%
        height: 100%
        // height: calc(100% - 2px)
        overflow-x: hidden
        overflow-y: auto

.under-construction
    flex-grow: 1
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center
    padding: 4rem
    text-align: center
    i
        font-size: 4rem
        color: rgba(0,0,0,0.2)
    h4
        margin-top: 1rem
        margin-bottom: 0
        font-size: 2rem
        font-weight: 300
        color: rgba(0,0,0,0.3)
</style>
